<template>
  <section class="content">
    <admin-header
      :title="'Reports'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminReport',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Reports',
        searchEntityScreen: 'Admin - Report search',
        filterEventName: 'admin-report-filter',
        filterName: 'ReportFilter',
        entityName: 'document'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminReport.vue?ebcc0090